// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListCard_list__z3D3K {
  list-style: disc;
  padding-left: 0.875rem;
}

.ListCard_list__z3D3K li {
  padding-left: 0.35rem;
}
.ListCard_list__z3D3K li:not(:last-child) {
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/%5Bid%5D/ListCard.module.scss","webpack://./src/pages/reporting/[id]/ListCard.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sBAAA;ACCF;;ADEA;EACE,qBAAA;ACCF;ADCE;EACE,mBAAA;ACCJ","sourcesContent":[".list {\n  list-style: disc;\n  padding-left: 0.875rem;\n}\n\n.list li {\n  padding-left: 0.35rem;\n\n  &:not(:last-child) {\n    margin-bottom: 1rem;\n  }\n}\n",".list {\n  list-style: disc;\n  padding-left: 0.875rem;\n}\n\n.list li {\n  padding-left: 0.35rem;\n}\n.list li:not(:last-child) {\n  margin-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `ListCard_list__z3D3K`
};
export default ___CSS_LOADER_EXPORT___;
